import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import PageHero from "@/components/layout/PageHero";
import { HERO_IMAGE } from "@/lib/stockImages";

function greeting() {
  const h = new Date().getHours();
  if (h < 12) return "Good morning";
  if (h < 17) return "Good afternoon";
  return "Good evening";
}

export default function DashboardHero({ firstName, onNewEnquiry }) {
  return (
    <PageHero
      image={HERO_IMAGE}
      tagline="Transforming windows into beautiful spaces"
      title={
        <span data-testid="dashboard-greeting">
          {greeting()}, <span className="text-accent">{firstName}</span>
        </span>
      }
      subtitle="Here's what's happening across your showroom today."
      action={
        <Button data-testid="new-enquiry-button" className="rounded-full px-5" onClick={onNewEnquiry}>
          <Plus className="h-4 w-4 mr-1.5" /> New Enquiry
        </Button>
      }
    />
  );
}
